module.exports = __webpack_public_path__ + "static/media/cpr-verification.8e470913.png";